<style lang="less">
	tr td:first-child{
		font-weight: bold;
		width: 25%;
	}
</style>
<template>
	<div class="pa-3" v-if="appointment">
		<p class="title">{{project.clientName}}<br/>
			<span class="subtitle-1">{{allowedDisplayName}}</span><br/>
			<span class="subtitle-2">{{ appointment.dateTime.toDate() | moment("dddd, MMMM Do YYYY, h:mm a") }}</span>
		</p>
		<v-alert v-if="recording && isModerator" dense outlined color="red" class="mt-2"><v-icon color="red" class="mr-2">mdi-checkbox-blank-circle</v-icon> Recording</v-alert>
		<v-simple-table>
			<tbody>
				<tr>
					<td>Quota</td>
					<td>{{ prettyPrint(appointment.quota, "TITLE")}}</td>
				</tr>
				<template v-if="appointment.additionalFields">
				<tr v-for="(field, i) in project.additionalFields" :key="i">
					<td>{{prettyPrint(field, "TITLE")}}:</td>
					<td>{{prettyPrint(appointment.additionalFields[field], "TITLE")}}</td>
				</tr>
				</template>
			</tbody>

		</v-simple-table>
		<v-btn block color="primary" dark class="mt-4 mr-2" @click="viewProject = 1">Project <v-icon>mdi-open-in-new</v-icon></v-btn>
		<v-btn block color="primary" dark class="mt-4">Screener <v-icon>mdi-open-in-new</v-icon></v-btn>
		<div v-if="live && isModerator" class="mt-4">
			<v-btn block v-if="!shareScreen" color="green" dark class="mr-2" @click="$emit('startScreenShare')">Share screen</v-btn>
			<v-btn block v-else color="red" dark class="mr-2" @click="$emit('endShareScreen')">Stop Screen Sharing</v-btn>
		</div>
		<v-divider
		class="mt-3 mb-3"
		></v-divider>
		<div v-if="live && isModerator">
			<span class="overline">Chat with the participant: </span><br/>
			<VideoChat :user="user" :appointment="appointment" :participant="participant"></VideoChat>
		</div>
		<div v-if="appointment.videoMeeting.observers">
			<span class="overline">Observers: </span><br/>
			<span v-for="observer in appointment.videoMeeting.observers" :key="observer.id">{{observer.name}}<br/></span>
		</div>
		<div class="ma-3" v-if="viewProject">
			<v-dialog v-model="viewProject"  hide-overlay transition="dialog-bottom-transition">
				<v-card class="pa-3">
					<v-btn absolute right icon @click="viewProject = false">
					<v-icon>mdi-close</v-icon>
					</v-btn>
					<ViewProject :project="project" :hideButtons="true"></ViewProject>
				</v-card>
			</v-dialog>	
		</div>
		<v-btn v-if="live" color="red" dark x-large width="100%" class="mt-4" @click="endVideo">Leave</v-btn>
		<v-dialog v-if="isModerator" v-model="showComments">
			<AppointmentComments :appointment="appointment" v-on:close="showComments = false"></AppointmentComments>
		</v-dialog>
	</div>
</template>

<script>

	import {prettyPrint} from "@/assets/utilities.js";
	import {visibleDisplayName} from "@/assets/permissionsFunctions.js"
	
	export default{
		name: 'ClientSidePanel',
		props: ["appointment", "project", "live",  "recording", "shareScreen", "user", "participant"],
		components: {
			ViewProject: () => import('../../singles/ViewProject'),
			AppointmentComments: () => import('../../tools/AppointmentComments'),
			VideoChat: () => import('../video/VideoChat'),
		},
		data: () => { 
			return {
				viewProject: false,
				viewScreener: false,
				showComments: false,
			} 
		},
		computed: {
			allowedDisplayName() {
				return visibleDisplayName( this.user, this.participant, this.project )
			},
			isModerator(){
				if( this.appointment.videoMeeting ){
					return this.appointment.videoMeeting.moderator == this.user.uid 
				}
				return false;
			},
			hasModerator(){
				if( this.appointment.videoMeeting ){
					return !(!this.appointment.videoMeeting.moderator); 
				}
				return false;
			}
		},
		methods:{
			prettyPrint: prettyPrint,
			endVideo: function(){
				this.$emit("endVideo");
				this.showComments = 1
			},
		}
	}
</script>